import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { ReactComponent as SendIcon } from '../../../../../assetsNew/icons/paper-airplane.svg';
import { ReactComponent as CheckIcon } from '../../../../../assetsNew/icons/check-circle.svg';
import { openBatchMessageReport } from '../../../../../sagas/batchMessage/actions';
import { getSendbirdBatchMessageInfoRequest } from '../../../../../sagas/sendbird/batchMessage/info/actions';

import './_failedItem.scss';

const FailedItem = ({ item }) => {
  const dispatch = useDispatch();

  const showReport = () => {
    dispatch(getSendbirdBatchMessageInfoRequest({
      id: item.id,
      onSuccess: data => {
        dispatch(openBatchMessageReport({
          id: data.task_id,
          status: data.status,
          users: data.failed_recipients
        }));
      }
    }));
  };

  return (
    <div className="failedItem">
      <div className="failedItem-status">
        <div className="failedItem-status__container">
          <SendIcon />
          <p className="failedItem-status__label">Some messages failed to send</p>
        </div>
        <div className="failedItem-status__check">
          <CheckIcon />
        </div>
      </div>
      <div className="failedItem-info">
        <p className="failedItem-info__message">{item.failed_count} {item.failed_count === 1 ? 'message' : 'messages'} failed to send. Go to the Messages tab for more information.</p>
        <p className="failedItem-info__report" onClick={showReport}>Show Report →</p>
      </div>
    </div>
  );
};

FailedItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.any,
    status: PropTypes.string,
    failed_count: PropTypes.number
  })
};

export default FailedItem;
